import { useState } from 'react';
import type { AlgoliaStoreType, StoreMapMarker } from '@storefront/lib-global';

export const useGetPagedStoreLocations = () => {
  const [hasLoadMore, setHasLoadMore] = useState(false);
  const [pagedStoresItems, setPagedStoresItems] = useState<AlgoliaStoreType[]>([]);
  const [pagedStoreMarkers, setPagedStoreMarkers] = useState<StoreMapMarker[]>([]);

  return {
    hasLoadMore,
    setHasLoadMore,
    pagedStoresItems,
    setPagedStoresItems,
    pagedStoreMarkers,
    setPagedStoreMarkers,
  };
};
